import { inject } from '@angular/core';
import { ENVIRONMENT } from '../tokens';

export const getEnvironment = () => inject(ENVIRONMENT);
